export default {
      id: "paperclip-usage",
      viewBox: "0 0 14 16",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#paperclip",
      toString: function () {
        return this.url;
      }
    }